import { render, staticRenderFns } from "./KontrowPrincipal.vue?vue&type=template&id=1a108392&"
import script from "./KontrowPrincipal.vue?vue&type=script&lang=js&"
export * from "./KontrowPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports